"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableControlsBar = TableControlsBar;
var _core = require("@dnd-kit/core");
var _sortable = require("@dnd-kit/sortable");
var _utilities = require("@dnd-kit/utilities");
var React = _interopRequireWildcard(require("react"));
var _buttonStyle = require("../../common/buttonStyle");
var _cardLevel = require("../../common/cardLevel");
var _classes = require("../../common/classes");
var _hooks = require("../../common/hooks");
var _paddingLevel = require("../../common/paddingLevel");
var _position = require("../../common/position");
var _Alerter = require("../alert/Alerter");
var _Button = require("../button/Button");
var _IconButton = require("../button/IconButton");
var _ToggleButton = require("../button/ToggleButton");
var _Card = require("../card/Card");
var _Divider = require("../divider/Divider");
var _Drawer = require("../drawer/Drawer");
var _DrawerBody = require("../drawer/DrawerBody");
var _DrawerFooter = require("../drawer/DrawerFooter");
var _DrawerHeader = require("../drawer/DrawerHeader");
var _Checkbox = require("../forms/Checkbox");
var _InputGroup = require("../forms/InputGroup");
var _iconNames = require("../icon/iconNames");
var _Frow = require("../layout/Frow");
var _Tooltip = require("../tooltip/Tooltip");
var _typography = require("../typography/typography");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Helpers
 */

/**
 * Column label helper (fallbacks to accessor or id)
 */
function getColumnLabel(column) {
  var header = column.columnDef.header;
  var _ref = column.columnDef,
    accessorKey = _ref.accessorKey;
  var label = typeof header === 'string' && header.trim() !== '' ? header : accessorKey || column.id || 'Unknown';
  return label.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/_/g, ' ').replace(/\b\w/g, function (char) {
    return char.toUpperCase();
  });
}

/**
 * Clear icon used inside search fields
 */
var getClearIcon = function getClearIcon(value, clearHandler) {
  return value.length > 0 ? /*#__PURE__*/React.createElement(_IconButton.IconButton24, {
    icon: _iconNames.IconNames8.CROSS,
    onClick: clearHandler,
    tagName: "span",
    "aria-label": "Clear"
  }) : undefined;
};
var isDataColumn = function isDataColumn(col) {
  var _col$columnDef$meta;
  return ((_col$columnDef$meta = col.columnDef.meta) === null || _col$columnDef$meta === void 0 ? void 0 : _col$columnDef$meta.isDataColumn) !== false;
};

/**
 * Tanstack drag and drop - Sortable card wrapper
 */
var SortableCard = function SortableCard(_ref2) {
  var id = _ref2.id,
    children = _ref2.children;
  var _useSortable = (0, _sortable.useSortable)({
      id: id
    }),
    attributes = _useSortable.attributes,
    listeners = _useSortable.listeners,
    setNodeRef = _useSortable.setNodeRef,
    transform = _useSortable.transform,
    transition = _useSortable.transition;
  var style = {
    transform: _utilities.CSS.Transform.toString(transform),
    transition: transition,
    touchAction: 'none'
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: setNodeRef,
    style: style
  }, children(listeners, attributes, setNodeRef));
};

/**
 * Debounce hook for the global search
 */
function useDebounce(value, delay) {
  var _React$useState = React.useState(value),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    debounced = _React$useState2[0],
    setDebounced = _React$useState2[1];
  React.useEffect(function () {
    var timer = setTimeout(function () {
      return setDebounced(value);
    }, delay);
    return function () {
      return clearTimeout(timer);
    };
  }, [value, delay]);
  return debounced;
}
function TableControlsBar(_ref3) {
  var table = _ref3.table,
    renderDrawerExtras = _ref3.renderDrawerExtras,
    leftItem = _ref3.leftItem,
    _ref3$showSearch = _ref3.showSearch,
    showSearch = _ref3$showSearch === void 0 ? false : _ref3$showSearch,
    _ref3$showAdvancedSea = _ref3.showAdvancedSearch,
    showAdvancedSearch = _ref3$showAdvancedSea === void 0 ? false : _ref3$showAdvancedSea,
    _ref3$showRadiusSearc = _ref3.showRadiusSearch,
    showRadiusSearch = _ref3$showRadiusSearc === void 0 ? false : _ref3$showRadiusSearc,
    _ref3$showFiltersButt = _ref3.showFiltersButton,
    showFiltersButton = _ref3$showFiltersButt === void 0 ? false : _ref3$showFiltersButt,
    _ref3$showCustomiseBu = _ref3.showCustomiseButton,
    showCustomiseButton = _ref3$showCustomiseBu === void 0 ? false : _ref3$showCustomiseBu,
    _ref3$forceDrawerOpen = _ref3.forceDrawerOpen,
    forceDrawerOpen = _ref3$forceDrawerOpen === void 0 ? false : _ref3$forceDrawerOpen;
  var _useVisibility = (0, _hooks.useVisibility)(forceDrawerOpen !== null && forceDrawerOpen !== void 0 ? forceDrawerOpen : false),
    isOpen = _useVisibility.isOpen,
    handleClose = _useVisibility.handleClose,
    toggleOpen = _useVisibility.toggleOpen;
  var _React$useState3 = React.useState(function () {
      return Object.fromEntries(table.getAllLeafColumns().map(function (col) {
        return [col.id, col.getIsVisible()];
      }));
    }),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    tempColumnVisibility = _React$useState4[0],
    setTempColumnVisibility = _React$useState4[1];
  var _React$useState5 = React.useState([]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    tempColumnOrder = _React$useState6[0],
    setTempColumnOrder = _React$useState6[1];
  var _React$useState7 = React.useState(''),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    globalFilter = _React$useState8[0],
    setGlobalFilter = _React$useState8[1];
  var _React$useState9 = React.useState(''),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    drawerSearch = _React$useState10[0],
    setDrawerSearch = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    groupVisibleColumns = _React$useState12[0],
    setGroupVisibleColumns = _React$useState12[1];
  var initialOrderRef = React.useRef([]);
  var initialVisibilityRef = React.useRef({});
  var pinnedColumnsSet = React.useMemo(function () {
    var pinned = table.getState().columnPinning;
    var pinnedIds = [].concat(_toConsumableArray(pinned.left || []), _toConsumableArray(pinned.right || []));
    return new Set(pinnedIds);
  }, [table]);
  var allColumnsMap = React.useMemo(function () {
    var map = new Map();
    table.getAllLeafColumns().forEach(function (column) {
      return map.set(column.id, column);
    });
    return map;
  }, [table]);
  var columnLabels = React.useMemo(function () {
    var map = new Map();
    table.getAllLeafColumns().forEach(function (col) {
      map.set(col.id, getColumnLabel(col));
    });
    return map;
  }, [table]);
  var debouncedFilter = useDebounce(globalFilter, 300);
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    isAdvancedSearchOpen = _React$useState14[0],
    setAdvancedSearchOpen = _React$useState14[1];
  var _React$useState15 = React.useState(false),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    isRadiusSearchOpen = _React$useState16[0],
    setRadiusSearchOpen = _React$useState16[1];
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    isFiltersOpen = _React$useState18[0],
    setFiltersOpen = _React$useState18[1];

  /**
   * Column state initialisation
   */
  var initColumnState = React.useCallback(function () {
    var initialOrder = table.getAllLeafColumns().map(function (c) {
      return c.id;
    });
    var initialVisibility = {};
    table.getAllLeafColumns().forEach(function (column) {
      if (column.getCanHide()) {
        initialVisibility[column.id] = column.getIsVisible();
      } else {
        initialVisibility[column.id] = true;
      }
    });
    initialOrderRef.current = initialOrder;
    initialVisibilityRef.current = initialVisibility;
    setTempColumnOrder(initialOrder);
    setTempColumnVisibility(initialVisibility);
  }, [table]);

  /**
   * Run once on mount to initialise refs
   */
  var hasInitialisedColumnStateRef = React.useRef(false);
  React.useEffect(function () {
    if (!hasInitialisedColumnStateRef.current) {
      initColumnState();
      hasInitialisedColumnStateRef.current = true;
    }
  }, [initColumnState]);

  /**
   * Restore temp visibility when drawer opens
   */
  React.useEffect(function () {
    if (isOpen) {
      var drawerColumnsVisibility = {};
      table.getAllLeafColumns().forEach(function (col) {
        drawerColumnsVisibility[col.id] = col.getIsVisible();
      });
      setTempColumnVisibility(drawerColumnsVisibility);
    }
  }, [isOpen, table]);
  var handleCheckboxChange = function handleCheckboxChange(columnId, checked) {
    setTempColumnVisibility(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, columnId, checked));
    });
  };

  /**
   * Drawer toggle all checkboxes
   */
  var toggleAllColumns = function toggleAllColumns(checked) {
    var newVisibility = {};
    table.getAllLeafColumns().forEach(function (column) {
      if (pinnedColumnsSet.has(column.id)) return;
      newVisibility[column.id] = column.getCanHide() ? checked : true;
    });
    setTempColumnVisibility(newVisibility);
  };

  /**
   * Handle drawer save state to table and close drawer
   */
  var handleSave = function handleSave() {
    table.setColumnVisibility(tempColumnVisibility);
    table.setColumnOrder(tempColumnOrder);
    handleClose();
  };

  /**
   * Handle reset visibility/order with confirm dialog
   */
  var handleReset = function handleReset() {
    _Alerter.Alerter.create({
      text: 'This will reset the columns to their default order and visibility states.',
      confirmButtonText: 'Reset',
      cancelButtonText: 'Cancel',
      onConfirm: function onConfirm() {
        setTempColumnOrder(_toConsumableArray(initialOrderRef.current));
        setTempColumnVisibility(_objectSpread({}, initialVisibilityRef.current));
        localStorage.removeItem('columnOrder');
        localStorage.removeItem('columnVisibility');
      }
    });
  };

  /**
   * Global filter search
   */
  React.useEffect(function () {
    table.setGlobalFilter(debouncedFilter);
  }, [debouncedFilter, table]);

  /**
   * Filtered column list
   */
  var filteredColumns = React.useMemo(function () {
    var matches = [];
    tempColumnOrder.forEach(function (columnId) {
      var _column$columnDef$met, _columnLabels$get, _extras$props, _extras$props2, _extras$props2$toStri;
      var column = allColumnsMap.get(columnId);

      // Skip columns that are not data columns
      if ((column === null || column === void 0 || (_column$columnDef$met = column.columnDef.meta) === null || _column$columnDef$met === void 0 ? void 0 : _column$columnDef$met.isDataColumn) === false) return;
      var label = (_columnLabels$get = columnLabels.get(columnId)) !== null && _columnLabels$get !== void 0 ? _columnLabels$get : '';
      var extras = renderDrawerExtras === null || renderDrawerExtras === void 0 ? void 0 : renderDrawerExtras(column);
      var drawerExtrasMatches = typeof (extras === null || extras === void 0 || (_extras$props = extras.props) === null || _extras$props === void 0 ? void 0 : _extras$props.children) === 'string' ? extras.props.children : (extras === null || extras === void 0 || (_extras$props2 = extras.props) === null || _extras$props2 === void 0 || (_extras$props2 = _extras$props2.children) === null || _extras$props2 === void 0 || (_extras$props2$toStri = _extras$props2.toString) === null || _extras$props2$toStri === void 0 ? void 0 : _extras$props2$toStri.call(_extras$props2)) || '';
      var match = label.toLowerCase().includes(drawerSearch.toLowerCase()) || drawerExtrasMatches.toLowerCase().includes(drawerSearch.toLowerCase());
      if (match) {
        matches.push(columnId);
      }
    });
    if (!groupVisibleColumns) return matches;
    var visible = matches.filter(function (id) {
      return tempColumnVisibility[id];
    });
    var hidden = matches.filter(function (id) {
      return !tempColumnVisibility[id];
    });
    return [].concat(_toConsumableArray(visible), _toConsumableArray(hidden));
  }, [tempColumnOrder, groupVisibleColumns, allColumnsMap, columnLabels, renderDrawerExtras, drawerSearch, tempColumnVisibility]);

  /**
   * Clear icon handlers for search bars
   */
  var handleClearGlobal = function handleClearGlobal() {
    return setGlobalFilter('');
  };
  var globalClearIcon = getClearIcon(globalFilter, handleClearGlobal);
  var handleClearDrawer = function handleClearDrawer() {
    return setDrawerSearch('');
  };
  var drawerClearIcon = getClearIcon(drawerSearch, handleClearDrawer);

  /**
   * Handle drag and drop
   */
  var handleDragEnd = function handleDragEnd(event) {
    var active = event.active,
      over = event.over;
    if (active && over && active.id !== over.id) {
      setTempColumnOrder(function (prev) {
        var oldIndex = prev.indexOf(active.id);
        var newIndex = prev.indexOf(over.id);
        return (0, _sortable.arrayMove)(prev, oldIndex, newIndex);
      });
    }
  };

  /**
   * Drag and drop sensors
   */
  var sensors = (0, _core.useSensors)((0, _core.useSensor)(_core.MouseSensor), (0, _core.useSensor)(_core.TouchSensor), (0, _core.useSensor)(_core.KeyboardSensor));

  /**
   * Toggle button handlers
   */
  var toggleAdvancedSearch = function toggleAdvancedSearch() {
    setAdvancedSearchOpen(function (prev) {
      return !prev;
    });
    setRadiusSearchOpen(false);
    setFiltersOpen(false);
  };
  var toggleRadiusSearch = function toggleRadiusSearch() {
    setRadiusSearchOpen(function (prev) {
      return !prev;
    });
    setAdvancedSearchOpen(false);
    setFiltersOpen(false);
  };
  var toggleFilters = function toggleFilters() {
    setFiltersOpen(function (prev) {
      return !prev;
    });
    setAdvancedSearchOpen(false);
    setRadiusSearchOpen(false);
  };

  /**
   * Drawer visibility settings state and count
   */
  var isDrawerSearching = drawerSearch.trim().length > 0;
  var selectableColumns = React.useMemo(function () {
    return table.getAllLeafColumns().filter(function (col) {
      return col.getCanHide() && isDataColumn(col);
    });
  }, [table]);
  var selectedCount = React.useMemo(function () {
    return selectableColumns.filter(function (col) {
      return tempColumnVisibility[col.id];
    }).length;
  }, [selectableColumns, tempColumnVisibility]);
  var totalSelectable = selectableColumns.length;
  return /*#__PURE__*/React.createElement(_Frow.Frow, {
    justifyContent: "space-between",
    alignItems: "center",
    className: _classes.Classes.TABLE_CONTROLS_BAR
  }, /*#__PURE__*/React.createElement("div", {
    className: _classes.Classes.TABLE_CONTROLS_LEFT
  }, leftItem, showSearch && /*#__PURE__*/React.createElement("div", {
    className: _classes.Classes.TABLE_CONTROLS_SEARCH_WRAPPER
  }, /*#__PURE__*/React.createElement("div", {
    className: _classes.Classes.TABLE_CONTROLS_INPUT_CONTAINER
  }, /*#__PURE__*/React.createElement(_InputGroup.InputGroup, {
    placeholder: "Search",
    leftIcon: _iconNames.IconNames16.MAGNIFYING_GLASS,
    rightElement: globalClearIcon,
    large: true,
    style: {
      width: '100%'
    },
    value: globalFilter,
    onChange: function onChange(e) {
      return setGlobalFilter(e.target.value);
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: _classes.Classes.TABLE_CONTROLS_RIGHT
  }, showAdvancedSearch && /*#__PURE__*/React.createElement(_Tooltip.Tooltip, {
    content: "Advanced search",
    position: _position.Position.BOTTOM_LEFT
  }, /*#__PURE__*/React.createElement(_ToggleButton.ToggleButton, {
    text: "ADVANCED",
    toggled: isAdvancedSearchOpen,
    onClick: toggleAdvancedSearch,
    buttonStyle: "tertiary",
    large: true,
    icon: _iconNames.IconNames16.MAGNIFYING_GLASS
  })), showRadiusSearch && /*#__PURE__*/React.createElement(_Tooltip.Tooltip, {
    content: "Radius search",
    position: _position.Position.BOTTOM_LEFT
  }, /*#__PURE__*/React.createElement(_ToggleButton.ToggleButton, {
    text: "RADIUS",
    toggled: isRadiusSearchOpen,
    onClick: toggleRadiusSearch,
    buttonStyle: "tertiary",
    large: true,
    icon: _iconNames.IconNames16.CROSSHAIR
  })), showFiltersButton && /*#__PURE__*/React.createElement(_Tooltip.Tooltip, {
    content: "Filter Table",
    position: _position.Position.BOTTOM_LEFT
  }, /*#__PURE__*/React.createElement(_ToggleButton.ToggleButton, {
    text: "FILTERS",
    toggled: isFiltersOpen,
    onClick: toggleFilters,
    buttonStyle: "tertiary",
    large: true,
    icon: _iconNames.IconNames16.FILTER
  })), showCustomiseButton && /*#__PURE__*/React.createElement(_Tooltip.Tooltip, {
    content: "Customise columns",
    position: _position.Position.BOTTOM_LEFT
  }, /*#__PURE__*/React.createElement(_Button.Button, {
    text: "CUSTOMISE",
    buttonStyle: "tertiary",
    onClick: toggleOpen,
    large: true,
    icon: _iconNames.IconNames16.COLUMNS_3,
    "aria-expanded": isOpen,
    "aria-controls": "customise-columns-heading"
  }))), /*#__PURE__*/React.createElement(_Drawer.Drawer, {
    isOpen: isOpen
  }, /*#__PURE__*/React.createElement(_DrawerHeader.DrawerHeader, {
    text: "Customise columns",
    handleClose: handleClose
  }), /*#__PURE__*/React.createElement(_DrawerBody.DrawerBody, null, /*#__PURE__*/React.createElement(_Frow.Frow, {
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "nowrap",
    style: {
      marginBottom: '16px'
    }
  }, /*#__PURE__*/React.createElement(_InputGroup.InputGroup, {
    placeholder: "Search",
    leftIcon: _iconNames.IconNames16.MAGNIFYING_GLASS,
    rightElement: drawerClearIcon,
    large: true,
    fill: true,
    value: drawerSearch,
    onChange: function onChange(e) {
      return setDrawerSearch(e.target.value);
    }
  })), /*#__PURE__*/React.createElement(_Card.Card, {
    level: _cardLevel.CardLevel.FILLED,
    paddingLevel: _paddingLevel.PaddingLevel.NONE,
    cardInnerProps: {
      style: {
        marginBottom: '16px'
      }
    },
    className: _classes.Classes.TABLE_DRAWER_VISIBILLITY_SETTINGS
  }, /*#__PURE__*/React.createElement(_Frow.Frow, {
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "nowrap"
  }, !isDrawerSearching && /*#__PURE__*/React.createElement(_Frow.Frow, {
    alignItems: "center",
    flexWrap: "nowrap"
  }, /*#__PURE__*/React.createElement(_Checkbox.Checkbox, {
    label: "Select all",
    checked: Object.entries(tempColumnVisibility).filter(function (_ref4) {
      var _allColumnsMap$get;
      var _ref5 = _slicedToArray(_ref4, 1),
        id = _ref5[0];
      return (_allColumnsMap$get = allColumnsMap.get(id)) === null || _allColumnsMap$get === void 0 ? void 0 : _allColumnsMap$get.getCanHide();
    }).every(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
        visible = _ref7[1];
      return visible;
    }),
    onChange: function onChange(e) {
      return toggleAllColumns(e.currentTarget.checked);
    }
  }), /*#__PURE__*/React.createElement(_typography.Caption, {
    muted: true
  }, "(".concat(totalSelectable, " items)")), /*#__PURE__*/React.createElement(_Divider.Divider, {
    muted: true,
    style: {
      height: '24px',
      marginLeft: '16px'
    }
  }), /*#__PURE__*/React.createElement(_Checkbox.Checkbox, {
    label: "Group selected items",
    checked: groupVisibleColumns,
    onChange: function onChange(e) {
      return setGroupVisibleColumns(e.target.checked);
    }
  }), /*#__PURE__*/React.createElement(_typography.Caption, {
    muted: true
  }, "(".concat(selectedCount, "/").concat(totalSelectable, " selected)"))))), /*#__PURE__*/React.createElement(_core.DndContext, {
    collisionDetection: _core.closestCenter,
    onDragEnd: handleDragEnd,
    sensors: sensors
  }, /*#__PURE__*/React.createElement(_sortable.SortableContext, {
    items: filteredColumns,
    strategy: _sortable.verticalListSortingStrategy
  }, filteredColumns.map(function (columnId) {
    var column = allColumnsMap.get(columnId);
    if (!column) return null;
    return /*#__PURE__*/React.createElement(SortableCard, {
      key: column.id,
      id: column.id
    }, function (listeners, attributes) {
      var _columnLabels$get2;
      return /*#__PURE__*/React.createElement(_Card.Card, {
        level: _cardLevel.CardLevel.FILLED,
        interactive: true,
        paddingLevel: _paddingLevel.PaddingLevel.NONE,
        cardInnerProps: {
          style: {
            marginBottom: '8px'
          }
        },
        className: _classes.Classes.TABLE_DRAWER_SORTABLE_CARD
      }, /*#__PURE__*/React.createElement(_Frow.Frow, {
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "nowrap"
      }, /*#__PURE__*/React.createElement(_Frow.Frow, {
        alignItems: "center",
        flexWrap: "nowrap"
      }, !isDrawerSearching && /*#__PURE__*/React.createElement(_Button.Button, _extends({
        buttonStyle: _buttonStyle.ButtonStyle.SECONDARY,
        icon: _iconNames.IconNames16.GRIP,
        style: {
          cursor: 'grab'
        }
      }, listeners, attributes)), /*#__PURE__*/React.createElement(_Checkbox.Checkbox, {
        key: column.id,
        label: (_columnLabels$get2 = columnLabels.get(column.id)) !== null && _columnLabels$get2 !== void 0 ? _columnLabels$get2 : '',
        disabled: !column.getCanHide(),
        checked: tempColumnVisibility[column.id] !== false,
        onChange: function onChange(e) {
          var target = e.target;
          handleCheckboxChange(column.id, target.checked);
        }
      })), /*#__PURE__*/React.createElement(_Frow.Frow, {
        alignItems: "center",
        flexWrap: "nowrap"
      }, /*#__PURE__*/React.createElement("div", {
        className: _classes.Classes.TABLE_DRAWER_EXTRA_CONTENT
      }, renderDrawerExtras && renderDrawerExtras(column)))));
    });
  })))), /*#__PURE__*/React.createElement(_DrawerFooter.DrawerFooter, null, /*#__PURE__*/React.createElement(_Frow.Frow, {
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Button.Button, {
    large: true,
    buttonStyle: _buttonStyle.ButtonStyle.TERTIARY,
    onClick: handleClose,
    text: "Cancel"
  })), /*#__PURE__*/React.createElement(_Frow.Frow, {
    style: {
      gap: '16px'
    }
  }, /*#__PURE__*/React.createElement(_Button.Button, {
    large: true,
    buttonStyle: _buttonStyle.ButtonStyle.TERTIARY,
    onClick: handleReset,
    text: "Reset"
  }), /*#__PURE__*/React.createElement(_Button.Button, {
    large: true,
    buttonStyle: _buttonStyle.ButtonStyle.PRIMARY,
    onClick: handleSave,
    text: "Save"
  }))))));
}